import React, { FC, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { isUndefined } from 'lodash';

import { getIsRequestInProgress } from '../global/globalStore';
import { getReferral } from '../dbStore/dbStore';
import { generatePath } from '../navigation/router';
import { routes } from '../../domain/routes';
import { getEnv } from '../../config/env';
import { activationMode } from '../../config/signupConfig';
import { useTranslation } from 'react-i18next';
const COPY_TXT_KEY = 'copy';

export const InviteFriendButton: FC = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'profile.referral' });

  const isLoading = useSelector(getIsRequestInProgress);
  const referral = useSelector(getReferral);
  const ref = useRef<HTMLInputElement | null>(null);
  const [copyText] = useState(COPY_TXT_KEY);

  const referralPath =
    activationMode === 'basic' ? routes.downloadCardByReferral : routes.signupTermsByReferral;

  const refUrl = new URL(
    generatePath(referralPath, {
      referralId: referral ? referral.refId : '1',
    }),
    getEnv().REACT_APP_URL,
  );

  if (isLoading) return <>Loading</>;

  if (!isUndefined(referral))
    return (
      <div className="c-copy">
        <input className="c-copy__type" type="text" value={refUrl.href} readOnly ref={ref} />
        <button className="c-copy__button c-button" type="button">
          <span className="c-copy__button--inner">{t(copyText)}</span>
        </button>
      </div>
    );

  return <button className="c-link">{t('buttonLabel')}</button>;
};
